/**
 * Komal OS - UI Store
 * Shared UI state: toast notifications and a global loading flag.
 * Real components (Toast container, LoadingSpinner) read from this store.
 */

import { create } from 'zustand';

let toastId = 0;

const useUIStore = create((set, get) => ({
  toasts: [],
  globalLoading: false,

  // Show a toast; auto-dismisses after `duration` ms (default 4s)
  showToast: (message, type = 'info', duration = 4000) => {
    const id = ++toastId;
    set((state) => ({
      toasts: [...state.toasts, { id, message, type }],
    }));

    if (duration > 0) {
      setTimeout(() => {
        get().dismissToast(id);
      }, duration);
    }

    return id;
  },

  dismissToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },

  clearToasts: () => set({ toasts: [] }),

  setGlobalLoading: (isLoading) => set({ globalLoading: isLoading }),
}));

export default useUIStore;
